// src/core/auth/logout.js
import { tokenStorage } from 'shared/api/storage';

export function logout() {
  tokenStorage.clear?.();
  window.location.href = '/sign-in'; // veya /
}
